export const getAcceptedFilesText = (formats: string[]): string =>
  `Accepted ${formats.join(", ")} files`;

export const isValidEmail = (value: string): boolean => {
  const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

  return !!String(value).match(EMAIL_REGEX);
};

const rowsFormatter = new Intl.NumberFormat("en-US");

/** "100,000 → 90,000" plus what was removed, or null when the job did not count its rows. */
export const formatRowCounts = (
  inputRows?: number | null,
  outputRows?: number | null,
): { counts: string; removed: string } | null => {
  if (inputRows == null || outputRows == null) return null;

  const removed = inputRows - outputRows;
  const percent = inputRows > 0 ? (Math.abs(removed) / inputRows) * 100 : 0;
  // Counted on the file before and after the whole pipeline, so the output is not guaranteed to
  // be smaller.
  const sign = removed < 0 ? "+" : removed > 0 ? "−" : "";

  return {
    counts: `${rowsFormatter.format(inputRows)} → ${rowsFormatter.format(outputRows)}`,
    removed: `${sign}${rowsFormatter.format(Math.abs(removed))} (${percent.toFixed(1)}%)`,
  };
};
